module.exports = __webpack_public_path__ + "static/media/left_mix.996b72df.png";